<template>
  <div class="column-global-menu">
    <div v-for="(item, groupIndex) in model" :key="'group' + groupIndex" class="group-item">
      <div class="title">
        <span class="title-text">{{ item.title }}</span>
        <div class="title-line"></div>
      </div>
      <div 
        v-for="(child, childIndex) in item.children" 
        :key="'child' + childIndex" 
        class="group-item__item" 
        :class="{ 'active': `${item.title}${childIndex}` === proxy.SiteMenu.columnChildIndex }" 
        @click="handleItemClick(child, `${item.title}${childIndex}`)"
      >
        <div class="item-content">
          <span class="item-name">{{ child?.getMenuInfo()?.name }}</span>
          <i v-if="`${item.title}${childIndex}` === proxy.SiteMenu.columnChildIndex" class="el-icon-check check-icon"></i>
        </div>
        
        <!-- Hover/Active Background Effect -->
        <div class="item-bg"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance } from 'vue'

const props = defineProps({
  model: {
    type: [Object, Array],
    default: () => []
  }
})

const emit = defineEmits(['item-click'])
const { proxy } = getCurrentInstance()
const store = proxy.$store

const handleItemClick = (item, index) => {
  proxy.SiteMenu.close()
  store.commit('editor/SET_SELECT_WIDGET_ID', item.id)
  store.commit('user/CLEAR_SITE_LOGIN_USER_MODAL')
  proxy.SiteMenu.setColumnChildIndex(index)
  
  const payload = Object.hasOwn(props.model, '__children') ? props.model : item
  emit('item-click', payload, index)
}
</script>

<style lang="less" scoped>
.column-global-menu {
  padding: 12px;
  width: 100%;
  box-sizing: border-box;

  .group-item {
    margin-top: 24px;
    
    &:first-child {
      margin-top: 8px;
    }

    .title {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      padding-left: 8px;
      
      .title-text {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.4);
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 1px;
        white-space: nowrap;
      }
      
      .title-line {
        height: 1px;
        flex: 1;
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.08), transparent);
        margin-left: 12px;
      }
    }

    &__item {
      position: relative;
      height: 44px;
      display: flex;
      align-items: center;
      padding: 0 16px;
      margin-bottom: 8px;
      cursor: pointer;
      border-radius: 12px;
      transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
      overflow: hidden;
      user-select: none;

      .item-content {
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        
        .item-name {
          font-size: 13px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.6);
          transition: all 0.3s ease;
          letter-spacing: 0.3px;
        }

        .check-icon {
          font-size: 14px;
          color: var(--primary-color);
          opacity: 0;
          transform: translateX(-10px);
          transition: all 0.3s ease;
        }
      }

      .item-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0);
        z-index: 1;
        transition: all 0.3s ease;
        border: 1px solid transparent;
        border-radius: 12px;
      }

      // Hover State
      &:hover {
        .item-content .item-name {
          color: rgba(255, 255, 255, 0.9);
          transform: translateX(4px);
        }
        
        .item-bg {
          background: rgba(255, 255, 255, 0.04);
          border-color: rgba(255, 255, 255, 0.08);
        }
      }

      // Active State
      &.active {
        .item-content {
          .item-name {
            color: #fff;
            font-weight: 600;
            transform: translateX(4px);
            text-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          }

          .check-icon {
            opacity: 1;
            transform: translateX(0);
            filter: drop-shadow(0 0 5px rgba(var(--primary-color-rgb), 0.6));
          }
        }

        .item-bg {
          background: linear-gradient(90deg, rgba(var(--primary-color-rgb), 0.15), rgba(var(--primary-color-rgb), 0.05));
          border-color: rgba(var(--primary-color-rgb), 0.3);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
}
</style>